import React from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import styled from 'styled-components';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import { MapLinksDropdown } from './MapLinksDropdown';

// Fix for default marker icons in react-leaflet
import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png';
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: markerIcon2x,
  iconUrl: markerIcon,
  shadowUrl: markerShadow,
});

const MapWrapper = styled.div`
  width: 100%;
  height: ${props => props.height || '250px'};
  border-radius: 8px;
  overflow: hidden;
  margin-top: 12px;
  border: 1.5px solid #e5e7eb;
  position: relative;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.06);
  transition: box-shadow 0.2s ease;

  &:hover {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }

  .leaflet-container {
    height: 100%;
    width: 100%;
    z-index: 1;
  }
`;

const MapButtons = styled.div`
  margin-top: ${props => props.theme.spacing.md};
`;

export const MiniMap = ({
  latitude,
  longitude,
  zoom = 13,
  height = '250px',
  showButtons = true,
  label = null,
  accuracy = null,
  openLinksUpward = false
}) => {
  const theme = {
    borderRadius: { md: '8px', sm: '4px' },
    spacing: { sm: '8px', xs: '4px' },
    colors: {
      border: '#e0e0e0',
      backgroundSecondary: '#f5f5f5',
      tint: '#007bff'
    },
    typography: {
      sizes: { small: '14px' }
    }
  };

  if (!latitude || !longitude) {
    return null;
  }

  const position = [latitude, longitude];

  return (
    <div>
      <MapWrapper height={height} theme={theme}>
        <MapContainer
          center={position}
          zoom={zoom}
          scrollWheelZoom={false}
          style={{ height: '100%', width: '100%' }}
        >
          <TileLayer
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          <Marker position={position}>
            <Popup>
              {label && <strong>{label}</strong>}
              {label && <br />}
              {latitude.toFixed(6)}, {longitude.toFixed(6)}
              {accuracy && <><br />Accuracy: ±{Math.round(accuracy)}m</>}
            </Popup>
          </Marker>
        </MapContainer>
      </MapWrapper>

      {showButtons && (
        <MapButtons theme={theme}>
          <MapLinksDropdown
            latitude={latitude}
            longitude={longitude}
            label="Open in Maps"
            openUpward={openLinksUpward}
          />
        </MapButtons>
      )}
    </div>
  );
};

export default MiniMap;
